import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';

const META = {
  management_control: {
    title: 'Management Control',
    scorecardPath: '/management/scorecard',
    submitPath: '/management/submit-datasheet',
  },
  management_control_transport: {
    title: 'Management Control (Transport)',
    scorecardPath: '/management/scorecard/management-control-transport',
    submitPath: '/management/submit-datasheet/management-control-transport',
  },
};

const ManagementControl = () => {
  const navigate = useNavigate();
  const { elementKey: rawElementKey } = useParams();
  const elementKey = (rawElementKey || 'management_control').replace(/-/g, '_');
  const meta = META[elementKey] || META.management_control;

  const actions = [
    {
      label: 'Board Representation and Executive Management',
      onClick: () => navigate('/management/board-representation'),
      desc: 'Track board-level B-BBEE demographics',
      icon: (
        <svg viewBox="0 0 24 24">
          <rect x="2" y="7" width="20" height="14" rx="2"/>
          <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
          <line x1="12" y1="12" x2="12" y2="16"/>
          <line x1="10" y1="14" x2="14" y2="14"/>
        </svg>
      ),
    },
    {
      label: 'Management Control Scorecard',
      onClick: () => navigate(meta.scorecardPath),
      desc: 'Management control scorecard data and compliance tracking',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
          <rect x="9" y="3" width="6" height="4" rx="1"/>
          <line x1="9" y1="12" x2="15" y2="12"/>
          <line x1="9" y1="16" x2="13" y2="16"/>
        </svg>
      ),
    },
    {
      label: 'Documentation Upload',
      onClick: () => navigate(`/management/documentation/${elementKey}`),
      desc: 'Upload management control data for scorecard compliance',
      icon: (
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="8" r="4"/>
          <path d="M6 20v-2a6 6 0 0 1 12 0v2"/>
        </svg>
      ),
    },
    {
      label: 'Other Management',
      onClick: () => navigate('/management/other'),
      desc: 'Senior, Middle and Junior Management demographics and data',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
          <line x1="22" y1="11" x2="16" y2="11"/>
        </svg>
      ),
    },
    {
      label: 'Reports & KPI Tracking',
      onClick: () => navigate('/reports/scorecard'),
      desc: 'View compliance and scoring reports',
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      ),
    },
    {
      label: 'Submit Data Sheet',
      onClick: () => navigate(meta.submitPath),
      desc: 'Enter and submit scorecard data',
      icon: (
        <svg viewBox="0 0 24 24">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
      ),
    },
  ];

  return (
    <DashboardPage
      theme={elementKey}
      title={meta.title}
      subtitle="B-BBEE Scorecard — Management Control Element"
      actions={actions}
      backTo="/"
    />
  );
};

export default ManagementControl;
